<button
  [disabled]="backIsDisabled()"
  mat-button
  (click)="onClickB()"
  class="p-0 text-mat-ef-revolution-secondary-500 disabled:opacity-50 max-w-fit min-w-fit"
>
  <mat-icon svgIcon="chevron_left" class="w-8 h-8"></mat-icon>
</button>
